// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".L43zMQWGqZDaa73CcQq6{padding:8px 0}.PzYnFKKd7lArfEMlZkHk{padding:8px 0;text-align:right}", "",{"version":3,"sources":["webpack://./node_modules/@microsoft/portal-app/lib/Options/OptionsPane/Options.scoped.scss"],"names":[],"mappings":"AAEA,sBACE,aAAA,CAGF,sBACE,aAAA,CACA,gBAAA","sourcesContent":["@import '../../styling/mixins.scss';\n\n.section {\n  padding: ($ms-grid-unit) 0;\n}\n\n.footerNotice {\n  padding: ($ms-grid-unit) 0;\n  text-align: right;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"section": "L43zMQWGqZDaa73CcQq6",
	"footerNotice": "PzYnFKKd7lArfEMlZkHk"
};
module.exports = ___CSS_LOADER_EXPORT___;
